"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDollar = exports.toCHF = exports.toZAR = exports.toGBP = exports.toDollarAllRegions = exports.toCurrencyNotDollars = exports.toDollars = exports.toCents = exports.CENTS_PER_CURRENCY = exports.CENTS_PER_DOLLAR = void 0;
const decimal_js_1 = require("decimal.js");
const numeral_1 = __importDefault(require("numeral"));
require("numeral/locales/en-gb");
require("numeral/locales/en-za");
require("numeral/locales/fr-ch");
require("numeral/locales/en-au");
require("numeral/locales/de");
exports.CENTS_PER_DOLLAR = 100;
exports.CENTS_PER_CURRENCY = 100;
/**
 * Given a number, string, or another Decimal value, convert the value
 * to numeric cents.
 *
 * *Note* It is assumed that the value is currently not in cents, that is,
 * it has a decimal point because it is expressed in dollars.
 *
 * @param {Decimal.Value} value
 * The value to convert to cents.
 *
 * @returns {Number}
 * The value, converted to cents.
 */
function toCents(value) {
    return new decimal_js_1.Decimal(value).times(exports.CENTS_PER_DOLLAR).truncated().toNumber();
}
exports.toCents = toCents;
/**
 * Given a number, string, or another Decimal value, convert the value
 * to numeric dollars.
 *
 * *Note* It is assumed that the value is currently not in dollars, that is,
 * it has no decimal point because it is expressed in integer cents.
 *
 * @param {Decimal.Value} value
 * The value to convert to dollars.
 *
 * @returns {Number}
 * The value, converted to dollars.
 */
function toDollars(value) {
    return new decimal_js_1.Decimal(value).dividedBy(exports.CENTS_PER_DOLLAR).toNumber();
}
exports.toDollars = toDollars;
/**
 * Accounts for currency other than dollars
 * Given a number, string, or another Decimal value, convert the value
 * to numeric currency.
 *
 * *Note* It is assumed that the value is currently not in the appropriate currency, that is,
 * it has no decimal point because it is expressed in integer cents.
 *
 * @param {Decimal.Value} value
 * The value to convert to currency.
 *
 * @returns {Number}
 * The value, converted to currency format.
 */
function toCurrencyNotDollars(value) {
    return new decimal_js_1.Decimal(value).dividedBy(exports.CENTS_PER_CURRENCY).toNumber();
}
exports.toCurrencyNotDollars = toCurrencyNotDollars;
/**
 * @deprecated
 * Given a number, string, or another Decimal value, convert the value
 * to Dollar.
 *
 * *Note* It is assumed that the value is currently not in dollars, that is,
 * it has no decimal point because it is expressed in integer cents.
 *
 * @param {Decimal.Value} value
 * The value to convert to currency.
 *
 * @returns {String}
 * The value, converted to dollars, formatted as currency.
 */
function toDollarAllRegions(value) {
    numeral_1.default.locale('en-au');
    const currency = numeral_1.default(toCurrencyNotDollars(value)).format('$0,0.00');
    numeral_1.default.locale(undefined);
    return currency;
}
exports.toDollarAllRegions = toDollarAllRegions;
/**
 * @deprecated
 * Given a number, string, or another Decimal value, convert the value
 * to GBP.
 *
 * *Note* It is assumed that the value is currently not in pounds, that is,
 * it has no decimal point because it is expressed in integer pence.
 *
 * @param {Decimal.Value} value
 * The value to convert to currency.
 *
 * @returns {String}
 * The value, converted to pounds, formatted as currency.
 */
function toGBP(value) {
    numeral_1.default.locale('en-gb');
    const currency = numeral_1.default(toCurrencyNotDollars(value)).format('$0,0.00');
    numeral_1.default.locale(undefined);
    return currency;
}
exports.toGBP = toGBP;
/**
 * @deprecated
 * Given a number, string, or another Decimal value, convert the value
 * to ZAR.
 *
 * *Note* It is assumed that the value is currently not in rands, that is,
 * it has no decimal point because it is expressed in integer cents.
 *
 * @param {Decimal.Value} value
 * The value to convert to currency.
 *
 * @returns {String}
 * The value, converted to rands, formatted as currency.
 */
function toZAR(value) {
    numeral_1.default.locale('en-za');
    const currency = numeral_1.default(toCurrencyNotDollars(value)).format('$0,0.00');
    numeral_1.default.locale(undefined);
    return currency;
}
exports.toZAR = toZAR;
/**
 * @deprecated
 * Given a number, string, or another Decimal value, convert the value
 * to CHF.
 *
 * *Note* It is assumed that the value is currently not in francs, that is,
 * it has no decimal point because it is expressed in integer cents.
 *
 * @param {Decimal.Value} value
 * The value to convert to currency.
 *
 * @returns {String}
 * The value, converted to francs, formatted as currency.
 */
function toCHF(value) {
    numeral_1.default.locale('fr-ch');
    const currency = numeral_1.default(toCurrencyNotDollars(value)).format('$0,0.00');
    numeral_1.default.locale(undefined);
    return currency;
}
exports.toCHF = toCHF;
/**
 * Given locale return a function take in a number, string, or another Decimal value, convert the value
 * to Dollar.
 *
 * *Note* It is assumed that the value is currently not in dollars, that is,
 * it has no decimal point because it is expressed in integer cents.
 * @param {String} locale
 * Locale to return currency format
 *
 * @param {Decimal.Value} value
 * The value to convert to currency.
 *
 * @returns {String}
 * The value, converted to dollars, formatted as currency.
 */
const toDollar = (locale) => (value) => {
    numeral_1.default.locale(locale);
    const currency = numeral_1.default(toCurrencyNotDollars(value)).format('$0,0.00');
    numeral_1.default.locale(undefined);
    return currency;
};
exports.toDollar = toDollar;
//# sourceMappingURL=money.js.map